import { produce } from 'immer';

import { OpenCampaignPlaceEditor } from '../../actions/campaignPlaceEditor/openCampaignPlaceEditor';
import { CampaignPlaceEditorState } from '../../typings/campaignPlaceEditor';

export function openCampaignPlaceEditor(
    state: CampaignPlaceEditorState,
    action: OpenCampaignPlaceEditor
): CampaignPlaceEditorState {
    return produce(state, draft => {
        const { editorId } = action;

        draft[editorId].isOpen = true;
    });
}
